import { createContext } from 'react';

export const BusinessTimezoneContext = createContext<string | null>(null);
